import ArrowDown from "@mui/icons-material/KeyboardArrowDown";
import ArrowUp from "@mui/icons-material/KeyboardArrowUp";
import {
  MenuItem,
  Select,
  SelectProps
} from "@mui/material";
import TextField from "@mui/material/TextField";
import React from "react";
import styled from "styled-components";
import { useApi } from "../../contexts/ApiContext";
import { InputProps } from "./InputProps";

const StyledTextField = styled(TextField)`
  margin: 8px 0;
`;

export interface DropDownInputOption {
  label: string;
  value: string;
}

export type DropDownInputPropsType = InputProps & SelectProps;

interface DropDownProps extends Omit<DropDownInputPropsType, "onChange"> {
  open: boolean;
  setOpen: (value: boolean) => void;
  onChange: (value: string) => void;
  options: DropDownInputOption[];
  globalColor?: string;
  fontSize?: number | string;
}

const DropDownInput: React.FC<DropDownProps> = ({
  options,
  open,
  setOpen,
  onChange,
  sx,
  globalColor = "#000000",
  fontSize = 24,
  ...rest
}) => {
  const sxVal = {
    "& .MuiOutlinedInput-notchedOutline": {
      border: "transparent",
    },
    "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
      borderColor: "transparent", // Removes border color on focus
      boxShadow: "none", // Removes the focus shadow
    },
    "& .MuiInputBase-input": {
      color: globalColor,
      fontSize,
    },
    ...sx,
  };

  const { isSubmitting, isLoading } = useApi();
  const isDisabled = isLoading || isSubmitting;

  return (
    <Select
      {...rest}
      disabled={isDisabled}
      sx={sxVal}
      onChange={(ev: any) => onChange(ev.target.value)}
      onOpen={() => setOpen(true)}
      onClose={() => setOpen(false)}
      IconComponent={open ? ArrowUp : ArrowDown}
      value={rest.value}
    >
      {options.map((option, index) => (
        <MenuItem
          key={index}
          sx={{ color: globalColor, fontSize }}
          value={option.value}
          selected={option.value === rest.value}
        >
          {option.label}
        </MenuItem>
      ))}
    </Select>
  );
};

export default DropDownInput;
